<template>
  <div>
    <!-- Mobile App Bar -->
    <v-app-bar
      app
      v-if="$vuetify.breakpoint.smAndDown"
      color="primary"
      collapse-on-scroll
      dark
    >
      <v-app-bar-nav-icon class="" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <span v-show="scrolled">Menu</span>
      <v-flex v-show="!scrolled" class="logo-bg-white center-bg mr-9" style="max-height:25px !important"></v-flex>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      disable-resize-watcher
      hide-overlay
      app
    >
      <v-list dense>
        <v-list-item @click.stop="left = !left" active-class="primary white--text" to="/dashboard">
          <v-list-item-action class="justify-center text-center">
            <v-icon>fas fa-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="text-right">Dashboard</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click.stop="left = !left" active-class="primary white--text" to="/aansluitingen">
          <v-list-item-action class="justify-center text-center">
            <v-icon>fas fa-plug</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="text-right">Aansluitingen</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click.stop="left = !left" active-class="primary white--text" to="/aanvragen">
          <v-list-item-action class="justify-center text-center">
            <v-icon>fas fa-network-wired</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="text-right">Aanvragen</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click.stop="left = !left" active-class="primary white--text" to="/storingen">
          <v-list-item-action class="justify-center text-center">
            <v-icon>fas fa-exclamation-triangle</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="text-right">Storingen</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click.stop="left = !left" active-class="primary white--text" to="/onderhoud">
          <v-list-item-action class="justify-center text-center">
            <v-icon>fas fa-tools</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="text-right">Onderhoud</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click.stop="left = !left" active-class="primary white--text" to="/acties">
          <v-list-item-action class="justify-center text-center">
            <v-icon>fas fa-tools</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="text-right">Acties</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item v-if="may($store.getters.permissions, 'companies', $store.getters.rights.RIGHT_READALL)" @click.stop="left = !left" class="grey darken-1 " active-class="primary white--text" to="/bedrijfsbeheer">
          <v-list-item-action class="justify-center text-center">
            <v-icon>fas fa-building</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="text-right">Bedrijfsbeheer</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider ></v-divider>
        <v-list-item @click.stop="left = !left" class="grey darken-1 " active-class="primary white--text" to="/profiel">
          <v-list-item-action class="justify-center text-center">
            <v-icon>fas fa-user</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="text-right">Mijn profiel</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider ></v-divider>
        <v-list-item @click.stop="left = !left" class="grey darken-1 " active-class="primary white--text"  @click="logout">
          <v-list-item-action class="justify-center text-center">
            <v-icon>fas fa-sign-out-alt</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="text-right">Uitloggen</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <!-- Desktop App Bar -->
    <v-app-bar
      fixed
      color="secondary"
      shrink-on-scroll
      class="py-0 main-head  pink-top"
      :class="{'smooth-border' : scrolled}"
      prominent
      v-if="$vuetify.breakpoint.mdAndUp"
    >
      <v-container fill-height pa-0 px-7 my-0 mx-auto class="max-container">
        <v-layout row wrap align-content-center>
          <v-flex xs12 fill-height>
            <v-layout justify-space-between align-content-center align-center fill-height>
              <v-flex fill-height py-3>
                <v-layout fill-height align-center>
                  <v-flex class="logo-bg" style="max-height: 73px;"> <a href="/dashboard" class="w-100 h-100 d-block"></a></v-flex>
                </v-layout>
              </v-flex>
              <v-flex>
                <v-expand-transition v-if="auth">
                  <v-layout justify-end v-show="!scrolled" align-start align-content-start>
                    <v-btn v-if="may($store.getters.permissions, 'companies', $store.getters.rights.RIGHT_READALL)" active-class="highlighted" to="/bedrijfsbeheer" color="transparent" class="mainmenu_butt no-boxshadow no-radius text-none title px-3 mx-2 gliscor">
                    Bedrijfsbeheer
                    </v-btn>
                    <v-divider vertical class="white" v-if="may($store.getters.permissions, 'companies', $store.getters.rights.RIGHT_READALL)"></v-divider>

                    <v-btn active-class="highlighted" to="/profiel" color="transparent" class="mainmenu_butt no-boxshadow no-radius text-none title px-3 mx-2 gliscor">
                      Mijn profiel
                    </v-btn>
                    <v-btn  @click="logout" outlined color="" class="no-boxshadow white--text pink-border no-radius my-0 mr-0 text-none title gliscor">Uitloggen</v-btn>
                  </v-layout>
                </v-expand-transition>
                <v-layout justify-end :class="{'mt-2' : !scrolled}" v-if="auth">
                  <v-btn active-class="highlighted" to="/dashboard" :ripple="{ center: true }" :large="!scrolled" tile color="transparent" class=" mr-6 no-boxshadow  text-none headline px-0 mainmenu_butt py-0 " :class="[scrolled ? 'title' : 'headline' ]"> Dashboard </v-btn>
                  <v-btn active-class="highlighted" to="/aansluitingen" :ripple="{ center: true }" :large="!scrolled" tile color="transparent" class="no-boxshadow  text-none headline px-0 mainmenu_butt py-0 mx-6" :class="[scrolled ? 'title' : 'headline' ]"> Aansluitingen</v-btn>
                  <v-btn active-class="highlighted" to="/aanvragen" :ripple="{ center: true }" :large="!scrolled" tile color="transparent" class="no-boxshadow  text-none headline px-0 mainmenu_butt py-0 mx-6" :class="[scrolled ? 'title' : 'headline' ]"> Aanvragen</v-btn>
                  <v-btn active-class="highlighted" to="/storingen" :ripple="{ center: true }" :large="!scrolled" tile color="transparent" class="no-boxshadow  text-none headline px-0 mainmenu_butt py-0 mx-6" :class="[scrolled ? 'title' : 'headline' ]"> Storingen </v-btn>
                  <v-btn active-class="highlighted" to="/onderhoud" :ripple="{ center: true }" :large="!scrolled" tile color="transparent" class="no-boxshadow  text-none headline px-0 mainmenu_butt py-0 ml-6" :class="[scrolled ? 'title' : 'headline' ]"> Onderhoud </v-btn>
                  <v-btn active-class="highlighted" to="/acties" :ripple="{ center: true }" :large="!scrolled" tile color="transparent" class="no-boxshadow  text-none headline px-0 mainmenu_butt py-0 ml-6" :class="[scrolled ? 'title' : 'headline' ]"> Acties </v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>

    </v-app-bar>

  </div>
</template>

<script>
export default {
  name: 'MainAppBar',

  data: () => ({
    drawer: false,
    drawerRight: false,
    right: false,
    left: false,

    expand: false,
    expand2: false,
    scrolled: false,
  }),

  methods: {
    handleScroll() {
      this.scrolled = window.scrollY > 1;
    },
	logout()
	{
		this.$store.dispatch('UserLogout').then(() => {
			this.$router.push({name: 'Dashboard'});
		});
	}
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  computed: {
	auth : {
		get() {
			return this.$store.getters.auth;
		},
	},
  }

};
</script>


<style scoped>


</style>
